export function getWsHost(url) {
  if (url.includes('ws://') || url.includes('wss://')) {
    return url;
  }

  if (window.location.protocol === 'https:') {
    console.error('You are using https, but the websocket protocol is not secure.');
  }

  const protocol = 'ws';
  const { host } = window.location;
  const pathPrefix = process.env.REACT_APP_API_PREFIX || '';

  return `${protocol}://${host}${pathPrefix}${url}`;
}
